import { render, staticRenderFns } from "./InicioDocenteGestionPage.vue?vue&type=template&id=f7e372e8"
import script from "./InicioDocenteGestionPage.js?vue&type=script&lang=js&external"
export * from "./InicioDocenteGestionPage.js?vue&type=script&lang=js&external"
import style0 from "./InicioDocenteGestionPage.vue?vue&type=style&index=0&id=f7e372e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports